// Configuration type
export interface Config {
  LOTUS_RECOMMENDATION_ENDPOINT: string;
}

export const getAsBoolean = (env: string | undefined): boolean => {
  return JSON.parse(env || "false");
};

export const getAsNumber = (env: string | undefined): number => {
  const parsedNumber = parseInt(env || "0", 10);
  return isNaN(parsedNumber) ? 0 : parsedNumber;
};

const onlyPublicConfig = {
  LOTUS_RECOMMENDATION_ENDPOINT:
    process.env.REACT_APP_LOTUS_RECOMMENDATION_ENDPOINT || "",
};

const config: Config = {
  ...onlyPublicConfig,
};

export { config, onlyPublicConfig };
